<script>
export default {
  name: 'MaskComponent',
  props: {
    path: {
      type: [Object, String],
    },
    mask: {
      type: String,
      required: true,
    },
  },
};
</script>

<template>
  <div v-bind="$attrs" class="mask-image"
       :style="{
    'mask-image': `url(${path})`,
    '-webkit-mask-image': `url(${path})`,
    background: mask,
  }"/>
</template>

<style scoped lang="scss">
.mask-image {
  mask-size: 100%;
  mask-position: center;
  mask-repeat: no-repeat;
}
</style>
